// NOTE: These routes are defined in .htaccess to override the app handling them (and redirecting)
export const G_OAUTH_REDIRECT_PATH = '/oauth/callback';
export const O_OAUTH_REDIRECT_PATH = '/oauth/callback';
export const Z_OAUTH_REDIRECT_PATH = '/oauth/callback';
export const M_OAUTH_REDIRECT_PATH = '/oauth/callback';
